<template>
    <div class="shortlist-item">
        <div class="shortlist-item__content">
            <div class="shortlist-item__image">
                <img v-if="image" :src="image" />
                <span v-else>
                    <Waiheke></Waiheke>
                </span>
            </div>
            <div class="shortlist-item__details">
                <p class="shortlist-item__title">{{ title }} {{ id }}</p>
                <p class="shortlist-item__summary">{{ summary }}</p>
            </div>
        </div>
        <div class="shortlist-item__actions">
            <button v-if="removeicon === 'backspace'" class="backspace" @click="$emit('remove')">
                <Backspace></Backspace>
            </button>
            <button v-else class="remove" @click="$emit('remove')">
                <Trash></Trash>
            </button>
            <button class="drag">
                <Drag></Drag>
            </button>
            <button class="link">
                <a :href="link" target="_blank">
                    <Link></Link>
                </a>
            </button>
        </div>
    </div>
</template>

<script>
import Trash from "@/vue/icons/Trash";
import Backspace from "@/vue/icons/Backspace";
import Drag from "@/vue/icons/Drag";
import Link from "@/vue/icons/Link";
import Waiheke from "@/vue/icons/Waiheke";

export default {
    components: {
        Trash,
        Backspace,
        Drag,
        Link,
        Waiheke,
    },
    props: {
        id: Number,
        link: String,
        title: String,
        summary: String,
        image: String,
        removeicon: String,
    },
};
</script>

<style lang="scss">
.shortlist-item {
    display: flex;
    justify-content: space-between;
    border-radius: 8px;
    border: 1px solid #f3f3f3;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
    padding: 15px;
    cursor: grab;
}

.shortlist-item:hover .shortlist-item__actions {
    opacity: 1;
}

@media (hover: none) {
    .shortlist-item .shortlist-item__actions {
        opacity: 1;
    }
}

.shortlist-item__content {
    display: grid;
    grid-template-columns: 140px auto;
}

.shortlist-item__image {
    // flex-basis: 140px;
    // min-width: 140px;
    // height: 90px;

    @media (min-width: 640px) {
        flex-basis: 140px;
        min-width: 140px;
        border: 1px solid #f3f3f3;
        height: 90px;
    }

    @media (min-width: 768px) {
        flex-basis: auto;
        min-width: auto;
        border: 1px solid #f3f3f3;
        height: auto;
    }

    @media (min-width: 1024px) {
        flex-basis: 140px;
        min-width: 140px;
        border: 1px solid #f3f3f3;
        height: 90px;
    }
}

.shortlist-item__image span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background-color: var(--color-yellow-400);
    padding: var(--grid-gap);
}

.shortlist-item__details {
    padding-left: var(--grid-gap);
}

.shortlist-item__summary {
    margin-top: 0.5em;
    font-size: 14px;
    color: var(--color-grey-600);
}

.shortlist-item__actions {
    display: flex;
    flex-direction: column;
    margin-left: var(--grid-gap);
    opacity: 0;
    transition: opacity 150ms ease-in;
}

.shortlist-item__actions button {
    position: relative;
    width: 21px;
    color: var(--color-grey-600);
}

.shortlist-item__actions button + button {
    margin-top: calc(var(--grid-gap) / 4);
}

.shortlist-item__actions button:before,
.shortlist-item__actions button:after {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 999;
    display: block;
    background-color: #333;
    color: var(--color-white);
    opacity: 0;
    pointer-events: none;
}

.shortlist-item__actions button:before {
    content: " ";
    width: 15px;
    height: 15px;
    transform: translate(-50%, calc(-100% - 5px)) rotate(45deg);
}

.shortlist-item__actions .remove:hover {
    color: var(--color-red-400);
}
.shortlist-item__actions .remove:after {
    content: "Remove";
}

.shortlist-item__actions .backspace:hover {
    color: var(--color-red-400);
}

.shortlist-item__actions .backspace:after {
    content: "Back to shortlist";
}


.shortlist-item__actions .drag {
    cursor: grab;
}
.shortlist-item__actions .drag:after {
    content: "Drag";
}

.shortlist-item__actions .link:hover {
    color: var(--color-blue-400);
}

.shortlist-item__actions .link {
    cursor: pointer;
}

.shortlist-item__actions .link:after {
    content: "View";
}

.shortlist-item__actions button:after {
    white-space: nowrap;
    padding: 4px 8px 4px 9px;
    border-radius: 5px;
    text-align: center;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-weight: 600;
    transform: translate(-50%, calc(-100% - 10px));
}

.shortlist-item__actions button:hover:after,
.shortlist-item__actions button:hover:before {
    opacity: 1;
    pointer-events: all;
}

.shortlist-item--ghost {
    opacity: 1;
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1);
}

.shortlist-item + .shortlist-item {
    // margin-top: calc(var(--grid-gap) / 2);

    // @media (min-width: 640px) {
    //     margin-top: 0;
    // }

    //@media (min-width: 76xpx) {
    //}
}

.journey-planner__shortlist-wrapper {
    .shortlist-item-wrapper {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        grid-gap: var(--grid-gap);

        @media (min-width: 768px) {
            grid-template-columns: repeat(2, 1fr);
        }

        @media (min-width: 1024px) {
            grid-template-columns: auto;
        }
    }

    .shortlist-item__content {
        grid-template-columns: auto;
        grid-template-rows: auto auto;

        @media (min-width: 640px) {
            grid-template-columns: 140px auto;
            grid-template-rows: auto;
        }

        @media (min-width: 768px) {
            grid-template-columns: auto;
            grid-template-rows: auto auto;
        }

        @media (min-width: 1024px) {
            grid-template-columns: 140px auto;
            grid-template-rows: auto;
        }
    }

    .shortlist-item__details {
        padding-top: var(--grid-gap);

        @media (min-width: 640px) {
            padding-top: 0;
            padding-left: calc(var(--grid-gap) / 2);
        }

        @media (min-width: 768px) {
            padding-top: calc(var(--grid-gap) / 2);
            padding-left: 0;
        }

        @media (min-width: 1024px) {
            padding-top: 0;
            padding-left: calc(var(--grid-gap) / 2);
        }
    }
}

</style>
